<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user', ['themeConfig']),
    themeCssVars() {
      const cssVars = {}
      const themeConfig = this.themeConfig || {}

      Object.keys(themeConfig).forEach((key) => {
        cssVars[`--${key}`] = themeConfig[key]
      })

      if (themeConfig.primaryColor) {
        cssVars['--primaryColorAlpha'] = `${themeConfig.primaryColor}1A`
      }

      return cssVars
    }
  }
}
</script>
